import React from 'react';

const DEFAULT_ALERT_DISMISS_DURATION = 3000;
const AlertContext = /*#__PURE__*/React.createContext({
  alerts: [],
  addAlert: () => {
    console.warn('addAlert called before it was initialized');
  },
  removeAlert: () => {
    console.warn('removeAlert called before it was initialized');
  },
  updateAlertContent: () => {
    console.warn('updateAlert called before it was initialized');
  }
});
var AlertContext$1 = AlertContext;

export { DEFAULT_ALERT_DISMISS_DURATION, AlertContext$1 as default };
//# sourceMappingURL=AlertContext.js.map
